import React, { useEffect, useState } from 'react'

import { Align, Button, Heading, Margin, TextStyle, Popup, Spacer } from 'component-library-next'

import { Document } from '@app/queries/CustomerAsLawyer/models'

export type Props = {
  setDocumentIdToDetach: (documentId: number | undefined) => void
  documentIdToDetach: number
  documents: Document[]
  messageIdToDelete?: number
  detachDocument: (documentId: number) => void
}

export const ConfirmDocumentDetachPopUp = ({
  setDocumentIdToDetach,
  documentIdToDetach,
  documents,
  detachDocument
}: Props) => {
  const [documentFileName, setDocumentFileName] = useState('')

  useEffect(() => {
    const documentToDetach = documents.find((eachDocument) => {
      return eachDocument.id === documentIdToDetach
    })

    setDocumentFileName(documentToDetach?.name || '')
  }, [documentIdToDetach])

  return (
    <Popup
      onClose={() => setDocumentIdToDetach(undefined)}
      onCloseButtonClick={() => setDocumentIdToDetach(undefined)}
    >
      <Align direction={Align.directions.center} textAlign={Align.textAligns.center}>
        <Heading size={Heading.sizes.small} color={Heading.colors.black}>
          Datei löschen?
        </Heading>
      </Align>
      <TextStyle>
        Die Datei <strong>{documentFileName}</strong> wird unwiderruflich gelöscht und ist für den
        Mandanten nicht mehr sichtbar.
      </TextStyle>
      <Spacer />
      <Align direction={Align.directions.center}>
        <Margin>
          <Button
            onClick={() => {
              detachDocument(documentIdToDetach)
              setDocumentIdToDetach(undefined)
            }}
            color={Button.colors.warning}
          >
            löschen
          </Button>
        </Margin>
        <Margin>
          <Button onClick={() => setDocumentIdToDetach(undefined)} color={Button.colors.minor}>
            zurück
          </Button>
        </Margin>
      </Align>
    </Popup>
  )
}
